import { FileText } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export interface ExpenseSourceDocumentTooltipProps {
  expenseId: number;
  documentId: number | null | undefined;
  documentFileName: string | null | undefined;
  delayDuration?: number;
}

export function ExpenseSourceDocumentTooltip({
  expenseId,
  documentId,
  documentFileName,
  delayDuration = 150,
}: ExpenseSourceDocumentTooltipProps) {
  if (!documentId) return null;
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="text-gray-400" data-testid={`icon-source-document-${expenseId}`}>
            <FileText className="h-3 w-3" />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" data-testid={`tooltip-source-document-${expenseId}`}>
          {documentFileName || "View source document"}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
